import type { PslfGroup } from 'tio-data/data/resources/pslf-group.type';
import type { PslfProfile } from './pslf-profile.type.ts';
export interface PslfProfileExtension extends PslfProfile {}
export class PslfProfileExtension {
  // ── Computed Properties ──
  normalizeFein(fein?: string) {
    return fein?.replace(/\D/g, '');
  }

  get fein() {
    const employeeFein =
      (this.employee.employeeAddition?.processed?.merged?.fein as string) ||
      this.employee.customAttributes?.fein;
    if (!employeeFein) {
      return;
    }
    return this.normalizeFein(employeeFein);
  }

  get partnerGroups() {
    return this.employee.company.pslfGroups;
  }

  get employerGroup() {
    if (!this.fein) {
      return;
    }
    return this.partnerGroups?.find(
      (group: PslfGroup) => this.normalizeFein(group.employerFein) === this.fein
    );
  }

  get feinIsRogue() {
    if (!this.fein || this.employerGroup) {
      return false;
    }
    return true;
  }

  /**
   * Derive the current employer from the most-recent currentEmployer form
   * (sorted by createdAt descending so the newest form wins).
   * Mirrors the logic previously in `reimagined-data.fetchPslfData()`.
   */
  get currentEmployer() {
    const form = this.pslfForms
      ?.filter((f) => f.formType === 'currentEmployer')
      .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())[0];
    if (!form) return null;
    return {
      name: form.employerDisplayName || 'Unknown Employer',
      startDate: form.employmentStartDate,
    };
  }
}

const Registration = {
  kind: 'object',
  name: 'pslf-profile',
  features: PslfProfileExtension,
};
export default Registration;
